import { render, staticRenderFns } from "./ROIChartVDPComparison.vue?vue&type=template&id=d77bb1c2&scoped=true&"
import script from "./ROIChartVDPComparison.vue?vue&type=script&lang=js&"
export * from "./ROIChartVDPComparison.vue?vue&type=script&lang=js&"
import style0 from "./ROIChartVDPComparison.vue?vue&type=style&index=0&id=d77bb1c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77bb1c2",
  null
  
)

export default component.exports